import { Backend, getQueryParamValue } from '@shared/datastore/core';
import { UsersGetResultApi } from 'api-typings/users/users';

declare module '../core/backend' {
  interface BackendApiFetchTypes {
    users: UsersGetResultApi;
  }
}

export const usersBackend: Backend<'users'> = {
  fetch: (_, userIds, query) => ({
    endpoint: `users/0.1/users`,
    params: {
      support_status_details: 'true',
      avatar: 'true',
      users: userIds || [],
      usernames: query ? getQueryParamValue(query, 'username') : [],
    },
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/users/users.backend.ts